import React, { useContext } from "react";
import { Autocomplete, FilterBar, Menu, SearchBar, Switch } from "@sscs/ui";
import { produce } from "immer";
import { initFilter, selectFilteredByLink } from "../../../store/malwareSlice";
import { TriagedFilterOption } from "../../common";
import { ReportContext } from "../../context";
import { useReportSelector } from "../../hooks";
import { useLazyGetThreatTypesQuery } from "../../services/malware.api";
import { isFilteredByLink } from "../../utils";
import styles from "./filter.module.scss";
const getOptionLabel = (option) => {
    return option === "ALL" ? "Show all detections" : option;
};
const Filter = ({ filter, onFilterChange }) => {
    var _a, _b;
    const { reportId } = useContext(ReportContext);
    const filteredByLink = useReportSelector(selectFilteredByLink);
    const [getThreatTypes, { data: threatTypesData = { threat_types: [] }, isLoading },] = useLazyGetThreatTypesQuery();
    return (React.createElement(FilterBar, { filters: [
            {
                id: "threat-name",
                minWidth: "280px",
                grow: 2,
                control: (React.createElement(SearchBar, { id: "malware-threat-name-search", value: (_a = filter.threat_name) !== null && _a !== void 0 ? _a : "", onChange: (value) => onFilterChange(produce(filter, (draftState) => {
                        draftState.threat_name = value === "" ? null : value;
                    })), label: "Regex search for threat name", className: styles["threat-name-filter"], slotProps: { htmlInput: { maxLength: 256 } }, "data-filtered-by-link": isFilteredByLink(filter, initFilter, "threat_name", filteredByLink) })),
            },
            {
                id: "threat-type",
                width: "280px",
                control: (React.createElement(Autocomplete, { id: "malware-filter-threat-type", label: "Filter by threat type", isClearAlwaysVisible: filter.threat_type !== initFilter.threat_type, value: (_b = filter.threat_type) !== null && _b !== void 0 ? _b : "ALL", onOpen: () => getThreatTypes({ ui_id: reportId }), options: [
                        "ALL",
                        ...threatTypesData.threat_types.map((threatType) => threatType.type),
                    ], loading: isLoading, getOptionLabel: getOptionLabel, onChange: (_event, value) => onFilterChange(produce(filter, (draftState) => {
                        draftState.threat_type = value === "ALL" ? null : value;
                    })), className: styles["threat-type-filter"], "data-filtered-by-link": isFilteredByLink(filter, initFilter, "threat_type", filteredByLink), renderOption: (props, option) => {
                        const threatType = threatTypesData.threat_types.find((threatTypeItem) => threatTypeItem.type === option);
                        const optionLabel = getOptionLabel(option);
                        return (React.createElement(Menu.Item, { ...props, className: styles["threat-type-filter-row"] },
                            optionLabel,
                            threatType && (React.createElement(TriagedFilterOption, { triaged: threatType.triaged }))));
                    } })),
            },
            {
                id: "triaged",
                fit: true,
                control: (React.createElement(Switch, { className: styles.switch, title: "Filter detections", label: "Hide triaged", id: "malware-filter-triaged", checked: filter.hide_triaged, onChange: (event) => onFilterChange(produce(filter, (draftState) => {
                        draftState.hide_triaged = event.target.checked;
                    })) })),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map